export const generateFlagLink = (countryCode: string) => {
	return `https://flagcdn.com/w40/${countryCode}.png`;
};
